import { UpperCasePipe, CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { analytics } from '@app/events/segment/analytics';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-summary-header',
  imports: [
    UpperCasePipe,
    RouterLink,
    CommonModule
  ],
  templateUrl: './summary-header.component.html',
  styleUrl: './summary-header.component.css'
})
export class SummaryHeaderComponent {
  @Input() title!: string;
  @Input() alternativeNames?: string;
  
  onNavigateBack() {
    analytics.track('Career Details Navigate Back', { section: 'explore' });
  }
}
